import { WorkflowActivityDefinition } from "./types";

const activityRegistry = new Map<string, WorkflowActivityDefinition>();

const unknownActivity: WorkflowActivityDefinition = {
  group: 'unknown',
  name: 'unknown',
  type: 'activity',
  schema: {},
};

export const registerActivity = (activity: WorkflowActivityDefinition) => {
  activityRegistry.set(activity.name, activity);
};

export const getActivity = (name: string) => {
  return activityRegistry.get(name) ?? unknownActivity;
};

export const getActivities = () => {
  return Array.from(activityRegistry.values());
};

export const getActivitiesWithGroups = (includeTriggers = false) => {
  const activities = getActivities();

  return activities.reduce((acc, activity) => {
    if (!acc[activity.group]) {
      acc[activity.group] = [];
    }

    const isTrigger = activity.type === 'trigger';
    const isIncluded = includeTriggers || !isTrigger;

    if (isIncluded) {
      acc[activity.group].push(activity);
    }

    return acc;
  }, {} as Record<string, WorkflowActivityDefinition[]>);
};
